import * as React from 'react';
import tokens from '@spotify-internal/tokens';

export enum Viewport {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
}

export const legacyViewportValues = {
  [Viewport.XS]: parseInt(tokens.screenXs, 10),
  [Viewport.SM]: parseInt(tokens.screenSm, 10),
  [Viewport.MD]: parseInt(tokens.screenMd, 10),
  [Viewport.LG]: parseInt(tokens.screenLg, 10),
  [Viewport.XL]: parseInt(tokens.screenXl, 10),
};

const smQuery = window.matchMedia(`(min-width: ${tokens.screenSmMin})`);
const mdQuery = window.matchMedia(`(min-width: ${tokens.screenMdMin})`);
const lgQuery = window.matchMedia(`(min-width: ${tokens.screenLgMin})`);
const xlQuery = window.matchMedia(`(min-width: ${tokens.screenXlMin})`);

const defaultQueries: Queries = {
  smQuery,
  mdQuery,
  lgQuery,
  xlQuery,
};

type Queries = {
  smQuery: MediaQueryList;
  mdQuery: MediaQueryList;
  lgQuery: MediaQueryList;
  xlQuery: MediaQueryList;
};

// @visibleForTesting
export function getMatch(queries: Queries) {
  let v = Viewport.XS;
  if (queries.smQuery.matches) v = Viewport.SM;
  if (queries.mdQuery.matches) v = Viewport.MD;
  if (queries.lgQuery.matches) v = Viewport.LG;
  if (queries.xlQuery.matches) v = Viewport.XL;
  return v;
}

export const useViewport: (queries?: Queries) => Viewport = (
  queries = defaultQueries,
) => {
  const [viewport, setViewport] = React.useState(() => getMatch(queries));
  const handleResize = () => setViewport(getMatch(queries));

  React.useEffect(() => {
    handleResize();
    queries.smQuery.addListener(handleResize);
    queries.mdQuery.addListener(handleResize);
    queries.lgQuery.addListener(handleResize);
    queries.xlQuery.addListener(handleResize);
    return () => {
      queries.smQuery.removeListener(handleResize);
      queries.mdQuery.removeListener(handleResize);
      queries.lgQuery.removeListener(handleResize);
      queries.xlQuery.removeListener(handleResize);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return viewport;
};
